import * as types from '@/store/mutation-types';
import Vue from 'vue';

export default {
  [types.addPartComment](state, partComment) {
    if (!state.selectedPartComments[partComment._id]) {
      Vue.set(state.selectedPartComments, partComment._id, partComment);
    }
  },
  [types.syncPartComment](state, partComment) {
    if (state.selectedPart && partComment.partId === state.selectedPart._id) {
      var index = state.selectedPartComments.findIndex((i) => i._id === partComment._id);
      if (index >= 0) {
        state.selectedPartComments[index] = partComment;
      } else {
        state.selectedPartComments.push(partComment);
      }
    }
    if (state.loggedInPerson && partComment.mentions[state.loggedInPerson._id]) {
      index = state.loggedInUserPartComments.findIndex((i) => i._id === partComment._id);
      if (index >= 0) {
        state.loggedInUserPartComments[index] = partComment;
      } else {
        var timeIndex = 0;
        while (
          timeIndex < state.loggedInUserPartComments.length &&
          partComment.commentdate < state.loggedInUserPartComments[timeIndex].commentdate
        ) {
          timeIndex++;
        }
        state.loggedInUserPartComments.splice(timeIndex, 0, partComment);
        // state.loggedInUserPartComments.push(partComment);
      }
    }
  },
  [types.setSelectedPartComments](state, comments) {
    state.selectedPartComments = comments;
  },
  [types.setLoggedInUserPartComments](state, comments) {
    state.loggedInUserPartComments = comments;
  },
};



// WEBPACK FOOTER //
// ./src/store/partComment/partCommentMutations.js